import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '$store/rootReducer';
import { LoadNotifyAction, NotifyState, SetItemsAction } from './interface';

const initialState: NotifyState = {
  isLoading: true,
  items: [],
  isTelegramConnected: false,
  nextFrom: '0',
  isLoadingMore: false,
};

export const { actions, reducer } = createSlice({
  name: 'notify',
  initialState,
  reducers: {
    load(state) {
      state.isLoading = true;
      state.items = [];
    },
    setItems(state, action: SetItemsAction) {
      state.isLoading = false;
      state.items = action.payload;
    },
    addItems(state, action: SetItemsAction) {
      const newItems = [...state.items];
      const exists: any = {};
      for (let item of newItems) {
        exists[item.id] = true;
      }

      for (let item of action.payload) {
        if (exists[item.id]) {
          continue;
        }

        newItems.push(item);
      }

      state.items = newItems;
    },
    setTelegramConnected(state, action: PayloadAction<boolean>) {
      state.isTelegramConnected = action.payload;
    },
    setNextFrom(state, action: PayloadAction<string>) {
      state.nextFrom = action.payload;
    },
    setLoadingMore(state, action: PayloadAction<boolean>) {
      state.isLoadingMore = action.payload;
    },
    loadMore(state) {
      state.isLoadingMore = true;
    },
  },
});

export { reducer as notifyReducer, actions as notifyActions };

export const notifySelector = (state: RootState) => state.notify;
